<template>
  <div class="sf-pad-2 sf-layer-border-bottom sf-level">
    <div
      class="
        sf-level
        sf-level-between
        sf-layer-rounded
        sf-bg-snow
        sf-pad-h-2
        sf-pad-v-1
        sf-full
      "
      @click="focusInput"
    >
      <span class="icon icon-search sf-dim-el" />
      <input
        ref="input"
        v-model="search"
        class="sf-form-input-transparent sf-full"
        type="text"
        :placeholder="placeholder"
        @keyup.enter="handleSearch"
      />
      <span
        v-show="showRemoveIcon"
        class="icon icon-remove sf-dim-el sf-pointer"
        @click="handleClear"
      />
    </div>
    <div class="sf-btn" @click="handleSearch">
      {{ I18n.t('permanent.search') }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true,
    },
  },
  emits: ['search'],
  data() {
    return {
      search: '',
    }
  },
  computed: {
    showRemoveIcon() {
      return this.search !== ''
    },
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.search)
    },
    handleClear() {
      this.search = ''
      this.$emit('search', '')
    },
    focusInput() {
      this.$refs.input.focus()
    },
  },
}
</script>
